import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../core/AddButton';
import CancelButton from '../core/CancelButton';
import Deprecated from '../core/Deprecated';
import Help from '../core/Help';
import Loading from '../core/Loading';
import ProjectLanguageSelector from '../core/ProjectLanguageSelector';
import { getResourceLabel } from '../core/utils/utils';
import SearchSelect from '../core/SearchSelect';
import { globalStyles } from '../core/style/gstheme';
import TitledPanel from '../core/TitledPanel';
import ComponentLinkList from './ontologyproject/ComponentLinkList';

const styles = Object.assign({}, globalStyles);

class AddIndividualClassDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            lang: props.defaultLang
        };
        this.cancellable = null;
    }

    handleClickOpen = () => this.setState({ open: true, lang: this.props.defaultLang, inherit: false });

    changeLanguage = (lang) => this.setState({ lang });

    computeSearch = (value, lang) => {
        let ebp = [];
        this.props.exclude && this.props.exclude.forEach(item => {
            // Existing item disjoint with result
            ebp.push({
                predicate: [
                    "http://www.w3.org/2002/07/owl#disjointWith",
                    "https://graphifi.com/schema/xowl/hasSubClass"
                ],
                target: item,
                reverse: true,
                pathOperators: ["", "*"]
            });
            ebp.push({
                predicate: [
                    "http://www.w3.org/2002/07/owl#disjointWith",
                    "https://graphifi.com/schema/xowl/hasSubClass"
                ],
                target: item,
                pathOperators: ["", "*"]
            });
            // Result disjoint with existing item
            ebp.push({
                predicate: [
                    "http://www.w3.org/2000/01/rdf-schema#subClassOf",
                    "http://www.w3.org/2002/07/owl#disjointWith"
                ],
                target: item,
                pathOperators: ["*", ""]
            });
            ebp.push({
                predicate: [
                    "http://www.w3.org/2000/01/rdf-schema#subClassOf",
                    "http://www.w3.org/2002/07/owl#disjointWith"
                ],
                target: item,
                reverse: true,
                pathOperators: ["*", ""]
            });
        });
        let search = [
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: "http://www.w3.org/2002/07/owl#Class"
            }
        ];
        if (value !== "") {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label",
                value: value,
                isExactMatch: false
            });
        }
        else {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label"
            });
        }
        let fullSearch =
        {
            search,
            graph: [this.props.graph],
            exclude: [
                "http://www.w3.org/2002/07/owl#Thing",
                "http://www.w3.org/2002/07/owl#Nothing",
                "http://www.w3.org/2002/07/owl#NamedIndividual",
                "http://www.w3.org/2002/07/owl#OwlClass",
                "http://www.w3.org/2002/07/owl#ObjectProperty",
                "http://www.w3.org/2002/07/owl#FunctionalProperty",
                "http://www.w3.org/2002/07/owl#InverseFunctionalProperty",
                "http://www.w3.org/2002/07/owl#SymmetricProperty",
                "http://www.w3.org/2002/07/owl#AsymmetricProperty",
                ...this.props.exclude
            ],
            ...(this.props.exclude) && {
                ...(ebp.length > 0) && { excludeByPath: ebp }
            },
            language: lang,
            ignoreNoLanguage: lang !== "und",
            pageSize: 100,
            predicates: [
                "http://www.w3.org/2000/01/rdf-schema#label",
                "http://www.w3.org/2002/07/owl#deprecated",
                "http://www.w3.org/2002/07/owl#disjointWith",
                "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
                "https://grafsync.graphifi.com/schema/gs/visibility"
            ]
        };
        return fullSearch;
    };

    addClass = (id) => {
        this.props.onAddClass(id, this.state.inherit);
        this.exitAddClass();
    };

    exitAddClass = () => this.setState({ open: false });

    render() {

        const { classes, exclude, textRef, defaultLang, graph, sourceComponent } = this.props;
        const { isLoading, lang } = this.state;

        if (isLoading) return <Loading />;

        return (
            <React.Fragment>
                <AddButton dataTest="add-local-class" onClick={() => this.handleClickOpen()} title="Add a class" />
                <Dialog
                    maxWidth="md"
                    fullWidth
                    data-test="add-class-dialog"
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    aria-labelledby="find-class-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-class-dialog-title">Add Class</DialogTitle>
                    <DialogContent style={{ height: 400, overflow: 'visible' }}>
                        {textRef && <Help textRef={textRef} />}
                        <div style={{ height: 320 }}>
                            <TitledPanel title="Language">
                                <ProjectLanguageSelector selectedLang={lang} includeLabel={false} onSelect={this.changeLanguage} />
                            </TitledPanel>
                            <SearchSelect
                                key={lang}
                                dataTest="find-class"
                                focus={true}
                                sortProp="label"
                                exclude={this.props.exclude}
                                wrapped={true}
                                search={(value, lang) => this.computeSearch(value, lang)}
                                listSecondIcon={(result) => {
                                    if (result.deprecated) return <Deprecated />;
                                    return null;
                                }}
                                listDisplay={(result, lang) => {
                                    const label = getResourceLabel(result, "label", lang);
                                    return <div>
                                        <Typography data-test="result-label" variant="body2">
                                            <Tooltip placement="left" title={result.id}>
                                                <span>{label}</span>
                                            </Tooltip>
                                        </Typography>
                                        <ComponentLinkList
                                            data={result}
                                            graph={graph}
                                            includeIsDefinedBy={true}
                                            context={sourceComponent}
                                            defaultLang={defaultLang}
                                        />
                                    </div>;
                                }}
                                isClickableResult={(result) => {
                                    if (result.invalid) return false;
                                    if (result.deprecated) return false;
                                    if (result.disjointWith) {
                                        // Exclude will be all existing classes so we test not disjoint with any existing class
                                        const clash = result.disjointWith.every(item => !exclude.includes(item));
                                        if (!clash) return false;
                                    }
                                    const okay = true;
                                    return okay;
                                }}
                                title="Filter classes"
                                lang={lang}
                                chosen={this.addClass} />
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddClass} />
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

AddIndividualClassDialog.defaultProps = {
    exclude: []
};

AddIndividualClassDialog.propTypes = {
    classes: PropTypes.object,
    sourceComponent: PropTypes.string,
    textRef: PropTypes.string,
    exclude: PropTypes.array,
    graph: PropTypes.string.isRequired,
    onAddClass: PropTypes.func.isRequired,
    viewLang: PropTypes.string,
    defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(AddIndividualClassDialog);